import { httpClient } from "@/services/httpClient";

/*
 * Auth endpoint wrappers.
 *
 * The token-injection and 401 refresh/replay logic that used to live in the
 * axios interceptors here now lives in httpClient. Auth endpoints (/api/v1/auth/*)
 * are intentionally excluded from the auto-refresh path there: a 401 from e.g.
 * the tenant-token endpoint should surface as an error in the UI, not a silent
 * logout, and the refresh endpoint itself must not recurse.
 */
export default {
  async refreshToken() {
    // Uses the HttpOnly refresh token cookie (credentials: "include")
    return httpClient.post("/api/v1/auth/refresh");
  },
  async login(payload) {
    const formData = new URLSearchParams();
    formData.append("grant_type", "password");
    formData.append("username", payload.username);
    formData.append("password", payload.password);
    return httpClient.post("/api/v1/auth/token", formData, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  },
  logout() {
    return httpClient.post("api/v1/auth/logout");
  },
  async forgotPassword(payload) {
    return httpClient.post("/forgot-password", payload);
  },
  async getCubejsToken(payload) {
    return httpClient.post("/api/v1/auth/cubejs/token", payload);
  },
  async getTenantToken(payload) {
    return httpClient.post("/api/v1/auth/tenant/token", payload);
  },
  async getAuthUser() {
    return httpClient.get("/api/v1/users/auth");
  },
  async resetPassword(payload) {
    return httpClient.post("/reset-password", payload);
  },
  updatePassword(payload) {
    return httpClient.put("/user/password", payload);
  },
  async registerUser(payload) {
    return httpClient.post("/register", payload);
  },
  sendVerification(payload) {
    return httpClient.post("/email/verification-notification", payload);
  },
};
